import BaseService from "./base.service";

class RoleService {

    roles(page = null, search = null) {
        let params = [];
        if(search) {
            params.push({'key':'q', 'value':search});
        }
        return BaseService.apiGetRequest('roles', page, params);
    }

    get(id) {
        return BaseService.apiGetRequest('roles/'+id);
    }
    delete(role) {
		return BaseService.apiPostRequest('roles/delete/', role);
    }
    add(role) {
        return BaseService.apiPostRequest('roles/add', role);
    }
    update(id, role) {
        return BaseService.apiPostRequest('roles/'+id, role);
    }
}
export default new RoleService();
